"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.audiencesV1 = exports.declineKeywords = exports.change = exports.createOne = exports.getOne = exports.getList = exports.remove = exports.duplicate = exports.audienceApi = exports.getTestsLinkedToAudience = exports.searchDatalayer = void 0;
const ramda_1 = require("ramda");
const format_1 = require("../../helpers/format");
const searchDatalayer = (caller) => (options) => {
    const { accountId, valueSearch } = options;
    const url = `/api/audience/datalayers/${accountId}/autocomplete?search=${valueSearch}`;
    return caller(url).get().then(format_1.cleanEmbedded);
};
exports.searchDatalayer = searchDatalayer;
const keepModifiableFieldsV1 = (audience) => (0, ramda_1.pick)(['name', 'description', 'hidden', 'groups', 'allow_duplicated_config', 'archive'], audience);
const getDatalayerTypes = (caller) => () => caller('/api/audience/datalayers').get();
const getTestsLinkedToAudience = (caller) => (options) => {
    const { accountId, audienceId } = options;
    const url = `/api/audience/accounts/${accountId}/audiences/${audienceId}/tests`;
    return caller(url).get({ active: options.active });
};
exports.getTestsLinkedToAudience = getTestsLinkedToAudience;
const audienceApi = (caller) => ({
    getDatalayerTypes: getDatalayerTypes(caller),
    searchDatalayer: (0, exports.searchDatalayer)(caller),
    getTestsLinkedToAudience: (0, exports.getTestsLinkedToAudience)(caller),
});
exports.audienceApi = audienceApi;
const duplicate = (caller) => ({ accountId, audienceId }) => {
    return caller(`/accounts/${accountId}/audiences`).post({ audience_id: audienceId }, { withResponse: true });
};
exports.duplicate = duplicate;
const remove = (caller) => ({ accountId, audienceId }) => {
    return caller(`/accounts/${accountId}/audiences/${audienceId}`).delete();
};
exports.remove = remove;
const getList = (caller) => ({ accountId, page, sortBy, filters = {}, maxPerPage = 20 }) => {
    const query = {
        _max_per_page: maxPerPage,
        _page: page,
        _order: sortBy,
        ...filters,
    };
    return caller(`/accounts/${accountId}/audiences`).get(query);
};
exports.getList = getList;
const getOne = (caller) => ({ accountId, audienceId }) => {
    return caller(`/accounts/${accountId}/audiences/${audienceId}`).get();
};
exports.getOne = getOne;
const createOne = (caller) => (options) => {
    const { accountId, payload } = options;
    return caller(`/accounts/${accountId}/audiences`).post(keepModifiableFieldsV1(payload), {
        withResponse: true,
    });
};
exports.createOne = createOne;
const change = (caller) => (options) => {
    const { accountId, audienceId, payload } = options;
    return caller(`/accounts/${accountId}/audiences/${audienceId}`).patch(keepModifiableFieldsV1(payload));
};
exports.change = change;
const declineKeywords = (caller) => ({ accountId, keywords }) => {
    return caller(`/accounts/${accountId}/declined-keywords`).put({ keywords });
};
exports.declineKeywords = declineKeywords;
const audiencesV1 = (caller) => ({
    duplicate: (0, exports.duplicate)(caller),
    delete: (0, exports.remove)(caller),
    list: (0, exports.getList)(caller),
    get: (0, exports.getOne)(caller),
    create: (0, exports.createOne)(caller),
    update: (0, exports.change)(caller),
    declineKeywords: (0, exports.declineKeywords)(caller),
});
exports.audiencesV1 = audiencesV1;
//# sourceMappingURL=api.js.map